import '@/lib/analytics/segment-boot';
import { type Models } from '@rematch/core';
import { audio } from './audioModel';
import { auth } from './authModel';
import { forceUpdateModel } from './forceUpdateModel';
import { scribeRecordModel } from './scribeRecordModel';
import { tauriRecordModel } from './tauriRecordModel';
import { tauriUpdateModel } from './tauriUpdateModel';
import { timerModel } from './timerModel';

export interface RootModel extends Models<RootModel> {
  auth: typeof auth;
  scribeRecordModel: typeof scribeRecordModel;
  audio: typeof audio;
  timerModel: typeof timerModel;
  tauriRecordModel: typeof tauriRecordModel;
  tauriUpdateModel: typeof tauriUpdateModel;
  forceUpdateModel: typeof forceUpdateModel;
}

export const models: RootModel = {
  auth,
  scribeRecordModel,
  audio,
  timerModel,
  tauriRecordModel,
  tauriUpdateModel,
  forceUpdateModel,
};
